import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzNoAnimationModule } from 'ng-zorro-antd/core/no-animation';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { MTableComponent } from './table.component';
import { MTableService } from './table.service';

@NgModule({
  imports: [CommonModule, FormsModule, NzPaginationModule, NzIconModule, NzDropDownModule, NzPopoverModule, NzNoAnimationModule],
  declarations: [MTableComponent],
  exports: [MTableComponent],
  providers: [MTableService]
})
export class MTableModule {}
